import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core'

export const visitor = defineStore('visitor', {
  state: () => {
    return {
      id: useStorage('id', null),
      name: useStorage('name', null),
      number: useStorage('number', null),
      auction: useStorage('auction', null),
      itemLimit: useStorage('itemLimit', false)
    }
  }
})
